import { Box, Typography } from "@mui/material";
import { Button } from "@/components/atoms";

export const UnauthenticatedState = () => {
  const navigateToLogin = () => {
    window.location.href = "/login";
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        gap: 2,
      }}
    >
      <Typography color="error.main" variant="h4" align="center">
        Please login to view this page
      </Typography>
      <Button
        componentName={"error-state"}
        variant="contained"
        color="primary"
        onClick={navigateToLogin}
      >
        To Login
      </Button>
    </Box>
  );
};
